<template>
	<div style="min-height: 100vh;">
		<div style="text-align: center;">
			<div class="panel">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						{{ main.name }} {{ $t('message.fittingRecordss') }}
					</div>
				</div>
				<div class="panel-body" style="min-height: 400px;">
					<div style="text-align: left;">
						<button class="btn btn-success mr-10" @click="back_home">{{ $t('message.backToCustomerList') }}</button>
						<button class="btn btn-success" @click="start_fitting">{{ $t('message.newFitting') }}</button>
					</div>
					<table class="table table-border table-bordered table-hover table-bg table-sort" style="margin-top: 20px;">
						<thead>
							<tr class="text-c">
								<th>{{ $t('message.name') }}</th>
								<th>{{ $t('message.time') }}</th>
								<th>{{ $t('message.status') }}</th>
								<th>{{ $t('message.actions') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr class="text-c" v-for="(item, index) in list" :key="index">
								<td>{{ item.Basicinformation == null ? $t('message.notProvided') : item.Basicinformation }}</td>
								<td>{{ item.time }}</td>
								<td>{{ item.state }}</td>
								<td class="td-manage">
									<button target="_blank" class="btn btn-success" v-if="item.state=='已完成' && item.report!=''" @click="go_bg(item.id, item.state)">
										{{ $t('message.downloadReport') }}
									</button>
									<button target="_blank" class="btn btn-success" v-if="item.state=='已完成' && item.report==''" @click="go_bg(item.id, item.state)">
										{{ $t('message.completeReport') }}
									</button>
									<button class="btn btn-success" v-if="item.state!='已完成'" @click="go_fitting(item.id, item.state)">
										{{ $t('message.continueFitting') }}
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login', // 组件的名称，根据实际情况替换 'YourComponentName'
		data() {
			return {
				// 在这里定义你的组件数据
				src: "",
				list: [],
				main: {
					name: ""
				}
			};
		},
		computed: {
			// 计算属性
		},
		methods: {
			back_home() {
				this.jref('/')
			},
			// 方法
			start_fitting() {
				var that = this
				$.ajax({
					url: that.URL,
					data: {
						t: "start_f",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						if (e.code == -1) {
							that.$router.push('/free');
						} else {
							if (e.code == 1) {
								alert("存在未完成的fitting记录");
							}
							that.go_fitting(e.fid, e.sta);
						}

					}
				})
			},
			go_bg(id, sta) {
				var that = this;
				var lang = this.$i18n.locale; // 获取当前语言
				location.href = "https://bike.typhcl.cn/dev/finish.php?id=" + id + "&token=" + localStorage.getItem('token') + "&lang=" + lang;
			},

			go_fitting(id, sta) {
				var that = this;
				var lang = this.$i18n.locale; // 获取当前语言

				switch (sta) {
					case "待测量":
						location.href = "https://bike.typhcl.cn/dev/step1.php?id=" + id + "&token=" + localStorage.getItem('token') + "&lang=" + lang;
						break;
					case "总结中":
						location.href = "https://bike.typhcl.cn/dev/step6.php?id=" + id + "&token=" + localStorage.getItem('token') + "&lang=" + lang;
						break;
					default:
						location.href = "https://bike.typhcl.cn/ffit/#/?id=" + id + "&lang=" + lang + "&token=" + localStorage.getItem('token');
						break;
				}
			},
			init() {
				var that = this
				// $.ajax({
				// 	url: that.URL,
				// 	data: {
				// 		t: "msg_init",
				// 		token: localStorage.getItem('token')
				// 	},
				// 	dataType: "json",
				// 	success(e) {
				// 		if (e.pid == 0) {
				// 			that.$router.replace('/login');
				// 		}
				// 		that.$data.main = e.main;
				// 	}
				// })
				$.ajax({
					url: that.URL,
					data: {
						t: "kh_main",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						that.main = e.main;
					}
				})
				$.ajax({
					url: that.URL,
					data: {
						t: "flist",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						that.$data.list = e.list;
					}
				})
			}
		},
		mounted() {

		},
		created() {
			var that = this
			that.$data.id = this.$route.query.id;
			// 组件挂载后执行的代码
			that.init()
		}
	}
</script>

<style>
	.row {
		margin-top: 20px;
	}
</style>